// Code generated by catalog-gen. DO NOT EDIT.
// Source: api/openapi.yaml (x-fexo-rbac annotations).
// catalog-source-sha256: 77ced373848eb0e98a8f8e911999942431ce08310ae8152601d520f27c85d564

// The RBAC permission vocabulary and resource catalog, mirrored from the server
// engine. capabilities.ts re-exports Module/Capability from here so the client
// vocabulary can never drift from rbac.Module/rbac.Capability; RBAC-006 renders
// views and field groups from CATALOG, and FE-001's role editor renders its
// selects from the four ladders below. Regenerate with `make openapi`.

export type Module =
  | 'work_orders'
  | 'trips'
  | 'parties'
  | 'locations'
  | 'catalogs'
  | 'drivers'
  | 'reports'
  | 'admin_users'
  | 'admin_roles'
  | 'admin_companies'
  | 'admin_subdivisions'
  | 'fuel_orders'
  | 'assets'
  | 'depot'
  | 'billing'
  | 'platform';

export const MODULES: readonly Module[] = [
  'work_orders',
  'trips',
  'parties',
  'locations',
  'catalogs',
  'drivers',
  'reports',
  'admin_users',
  'admin_roles',
  'admin_companies',
  'admin_subdivisions',
  'fuel_orders',
  'assets',
  'depot',
  'billing',
  'platform',
];

export type Capability =
  | 'view'
  | 'create'
  | 'edit'
  | 'approve'
  | 'export'
  | 'delete';

export const CAPABILITIES: readonly Capability[] = [
  'view',
  'create',
  'edit',
  'approve',
  'export',
  'delete',
];

export type AccessLevel =
  | 'none'
  | 'own'
  | 'own_match'
  | 'view_own'
  | 'view'
  | 'limited'
  | 'full';

export const ACCESS_LEVELS: readonly AccessLevel[] = [
  'none',
  'own',
  'own_match',
  'view_own',
  'view',
  'limited',
  'full',
];

export type DeviceClass =
  | 'phone'
  | 'tablet'
  | 'desktop';

export const DEVICE_CLASSES: readonly DeviceClass[] = [
  'phone',
  'tablet',
  'desktop',
];

export type DeviceLevel =
  | 'none'
  | 'read'
  | 'capture'
  | 'manage'
  | 'full';

export const DEVICE_LEVELS: readonly DeviceLevel[] = [
  'none',
  'read',
  'capture',
  'manage',
  'full',
];

export type FieldAccess =
  | 'none'
  | 'read'
  | 'write';

export const FIELD_ACCESS_LEVELS: readonly FieldAccess[] = [
  'none',
  'read',
  'write',
];

export type RowScopeMode =
  | 'assigned'
  | 'all';

export const ROW_SCOPE_MODES: readonly RowScopeMode[] = [
  'assigned',
  'all',
];

export interface Gate {
  module: Module;
  capability: Capability;
}

export interface ViewNode {
  name: string;
  requires: Gate;
}

export interface FieldGroup {
  name: string;
}

export interface ModuleCatalog {
  module: Module;
  views: readonly ViewNode[];
  fieldGroups: readonly FieldGroup[];
}

export const CATALOG: readonly ModuleCatalog[] = [
  {
    module: 'catalogs',
    views: [
      { name: 'synonym_admin', requires: { module: 'catalogs', capability: 'edit' } },
    ],
    fieldGroups: [
      { name: 'core' },
    ],
  },
  {
    module: 'drivers',
    views: [
      { name: 'detail', requires: { module: 'drivers', capability: 'view' } },
      { name: 'performance', requires: { module: 'drivers', capability: 'view' } },
      { name: 'roster', requires: { module: 'drivers', capability: 'view' } },
    ],
    fieldGroups: [
      { name: 'certifications' },
      { name: 'core' },
      { name: 'documents' },
      { name: 'identity' },
      { name: 'performance' },
      { name: 'ratings' },
    ],
  },
  {
    module: 'locations',
    views: [
      { name: 'detail', requires: { module: 'locations', capability: 'view' } },
      { name: 'list', requires: { module: 'locations', capability: 'view' } },
    ],
    fieldGroups: [
      { name: 'contact' },
      { name: 'core' },
    ],
  },
  {
    module: 'parties',
    views: [
      { name: 'detail', requires: { module: 'parties', capability: 'view' } },
      { name: 'list', requires: { module: 'parties', capability: 'view' } },
    ],
    fieldGroups: [
      { name: 'contact' },
      { name: 'core' },
      { name: 'identifiers' },
    ],
  },
  {
    module: 'platform',
    views: [
      { name: 'blocks', requires: { module: 'platform', capability: 'view' } },
      { name: 'config', requires: { module: 'platform', capability: 'view' } },
      { name: 'errlog', requires: { module: 'platform', capability: 'view' } },
      { name: 'fleet', requires: { module: 'platform', capability: 'view' } },
      { name: 'security', requires: { module: 'platform', capability: 'view' } },
      { name: 'status', requires: { module: 'platform', capability: 'view' } },
    ],
    fieldGroups: [
      { name: 'core' },
    ],
  },
  {
    module: 'trips',
    views: [
      { name: 'command_center', requires: { module: 'trips', capability: 'view' } },
      { name: 'detail', requires: { module: 'trips', capability: 'view' } },
      { name: 'list', requires: { module: 'trips', capability: 'view' } },
      { name: 'review_queue', requires: { module: 'trips', capability: 'approve' } },
    ],
    fieldGroups: [
      { name: 'audit' },
      { name: 'brief' },
      { name: 'core' },
      { name: 'driver_contact' },
      { name: 'invoice_financial' },
      { name: 'proof' },
      { name: 'statement_financial' },
    ],
  },
  {
    module: 'work_orders',
    views: [
      { name: 'detail', requires: { module: 'work_orders', capability: 'view' } },
      { name: 'list', requires: { module: 'work_orders', capability: 'view' } },
    ],
    fieldGroups: [
      { name: 'audit' },
      { name: 'core' },
      { name: 'financial' },
      { name: 'status' },
    ],
  },
];
